module.exports = __webpack_public_path__ + "static/paco-8b216ac29371e44594ff2bfd7523b5c0.jpg";